// Wallet connector for Telegram miniapp
export const USDC_ADDRESS = '0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238';
export const MARKET_ADDRESS = '0x757c3Cd4fF2905Ab8428A8949Fac82EaDAe06060';
export const CHAIN_ID = 11155111;
export const RPC_URL = 'https://ethereum-sepolia-rpc.publicnode.com';

export const USDC_ABI = [
  "function balanceOf(address owner) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)",
];

// Supported wallets with deeplinks
export const SUPPORTED_WALLETS = [
  {
    id: 'metamask',
    name: 'MetaMask',
    color: '#F6851B',
    icon: null, // using color fallback
    deeplink: (url) => `https://metamask.app.link/dapp/${url}`,
    injected: () => !!(window.ethereum?.isMetaMask),
  },
  {
    id: 'trust',
    name: 'Trust Wallet',
    color: '#3375BB',
    icon: null,
    deeplink: (url) => `https://link.trustwallet.com/open_url?coin_id=60&url=${encodeURIComponent('https://'+url)}`,
    injected: () => !!(window.ethereum?.isTrust),
  },
  {
    id: 'coinbase',
    name: 'Coinbase Wallet',
    color: '#1652F0',
    icon: null,
    deeplink: (url) => `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent('https://'+url)}`,
    injected: () => !!(window.ethereum?.isCoinbaseWallet),
  },
  {
    id: 'rainbow',
    name: 'Rainbow Wallet',
    color: '#174299',
    icon: null,
    deeplink: (url) => `https://rnbwapp.com/dapp?url=${encodeURIComponent('https://'+url)}`,
    injected: () => false,
  },
];

export async function connectInjectedWallet() {
  if (!window.ethereum) return null;
  const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
  // Switch to Sepolia
  try {
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: '0xaa36a7' }],
    });
  } catch(e) {
    if (e.code === 4902) {
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [{
          chainId: '0xaa36a7',
          chainName: 'Ethereum Sepolia',
          nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
          rpcUrls: [RPC_URL],
          blockExplorerUrls: ['https://sepolia.etherscan.io'],
        }]
      });
    }
  }
  return { address: accounts[0], provider: window.ethereum };
}

export async function getUsdcBalance(address, provider) {
  const { BrowserProvider, Contract, formatUnits } = await import('ethers');
  const ethProvider = new BrowserProvider(provider);
  const usdc = new Contract(USDC_ADDRESS, USDC_ABI, ethProvider);
  const [bal, dec] = await Promise.all([usdc.balanceOf(address), usdc.decimals()]);
  return parseFloat(formatUnits(bal, dec)).toFixed(2);
}

export function getAppUrl() {
  return window.location.hostname === 'localhost'
    ? 'app.naijapredict.net'
    : window.location.hostname;
}
